export class Gender {
  code: string;
  name: string;

  constructor(
    code: string,
    name: string,
  ) {
    this.code = code;
    this.name = name;
  }

  static createFromAny(object: any): Gender {
    if (object === null || object === undefined) {
      return null;
    }

    return new Gender(
      object.code,
      object.name,
    );
  }

}
